"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocationsResponse = exports.getLocationsResponseItem = void 0;
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * Generated API
 * OpenAPI spec version: 1.0
 */
const zod_1 = require("zod");
exports.getLocationsResponseItem = zod_1.z.object({
    uid: zod_1.z.string().min(1),
    name: zod_1.z.string().optional(),
    address1: zod_1.z.string().optional(),
    address2: zod_1.z.string().optional(),
    zip: zod_1.z.string().optional(),
    city: zod_1.z.string().optional(),
    state: zod_1.z.string().optional(),
    country: zod_1.z.string().optional(),
    type: zod_1.z.string().min(1),
    parking: zod_1.z.string().optional(),
    importantInfo: zod_1.z.string().optional(),
    open: zod_1.z.boolean().optional(),
    latitude: zod_1.z.number().optional(),
    longitude: zod_1.z.number().optional(),
    serviceTerritoryId: zod_1.z.string().optional(),
    isTestLocation: zod_1.z.boolean().optional(),
    lanes: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string().optional(),
        locationUid: zod_1.z.string().optional(),
        name: zod_1.z.string().optional(),
        description: zod_1.z.string().optional(),
        isAccessible: zod_1.z.boolean().optional(),
        accessibilityMessage: zod_1.z.string().optional(),
        importantInfo: zod_1.z.string().optional(),
        availability: zod_1.z
            .array(zod_1.z.object({
            days: zod_1.z.string().optional(),
            hours: zod_1.z.string().optional(),
        }))
            .optional(),
    }))
        .optional(),
});
exports.getLocationsResponse = zod_1.z.array(exports.getLocationsResponseItem);
//# sourceMappingURL=index.js.map